class DrilldownManager {
    static rootDrilldownId: number = -1;

    tab: WorkbookTab;
    dashboardWidget: DashboardWidget;
    tabOrWidget: ITabOrWidget;

    nextDrilldownId: KnockoutObservable<number>;
    drilldownList: KnockoutObservableArray<Drilldown>;
    //For DrilldownMiltiView component
    private _drilldownViewList: KnockoutObservableArray<DrilldownViewListItemVM>;
    
    get drilldownViewList() {
        if (!this._drilldownViewList) {
            let reportWidget = BaseWidget.createWidget(null, this.tab, this.dashboardWidget);
            this.tabOrWidget.widget = reportWidget;

            let drilldownViewListItem = new DrilldownViewListItemVM(this.tabOrWidget.name() ?? "Main Report", 0, reportWidget,
                () => {
                    let $widget = BaseWidget.getWidgetElement(reportWidget);
                    this.tabOrWidget.widgetContent = $widget;
                    return $widget;
                });

            this._drilldownViewList = ko.observableArray([
                drilldownViewListItem
            ]);
        }
        return this._drilldownViewList;
    }

    activeDrilldownIndex: KnockoutObservable<number>;

    get isWiddget() { return this.dashboardWidget !== null; }
    get isReportConfig() { return this.tabOrWidget?.itemConfig()?.isReportConfig ?? false; }

    get isDrilldown(): boolean {
        return this.activeDrilldownIndex() > 0;
    }

    get activeDrilldownId(): number {
        if (this.isDrilldown) {
            return this.getDrilldown(this.activeDrilldownIndex())?.id ?? -1;
        }

        return -1;
    }

    private _reportTemplateList: Array<Drilldown>;

    constructor(drilldownId: number, drilldownList: Array<any>, tab: WorkbookTab, dashboardWidget: DashboardWidget = null) {
        this.tab = tab;
        this.dashboardWidget = dashboardWidget;
        this.tabOrWidget = dashboardWidget ?? tab;

        this.drilldownList = ko.observableArray(createInstances(Drilldown, drilldownList ?? []));
        this.activeDrilldownIndex = ko.observable(0);
        this.nextDrilldownId = ko.observable(-1);
        if (this.drilldownList() && this.drilldownList().length > 1) {
            let nextDrilldownId = this.drilldownList()[1];
            if (nextDrilldownId) {
                this.nextDrilldownId(nextDrilldownId.id);
            }
        }
    }

    getActiveDrillViewItem() {
        return this.drilldownViewList()[this.activeDrilldownIndex()];
    }

    refresh() {
        let self = this;
        let drilldownViewItem = this.getActiveDrillViewItem();

        let $loading = $(`<loading></loading>`);
        ko.applyBindings({}, $loading[0]);
        drilldownViewItem.content.empty();
        drilldownViewItem.content.append($loading);

        let tabOrWidget = this.tabOrWidget;
        tabOrWidget.getWidgetData(function (result, error, errorMessage) {
            let activeWidget = tabOrWidget.drilldownManager.getActiveWidget();
            activeWidget.setResult(result);

            let drilldownViewItem = tabOrWidget.drilldownManager.getActiveDrillViewItem();
            drilldownViewItem.content.empty();
            let $widget = BaseWidget.getWidgetElement(activeWidget);
            drilldownViewItem.content.append($widget);
            if (!self.isDrilldown) {
                tabOrWidget.widgetContent = $widget;
            }
        }, false);
    }

    updateRootWidget(widget: IWidget) {
        this.drilldownViewList()[0].widget(widget);
    }

    updateCurrentWidget(widget: IWidget) {
        this.drilldownViewList()[this.activeDrilldownIndex()].widget(widget);
        if (!this.isDrilldown) {
            this.tabOrWidget.widget = widget;
        }
    }

    getActiveWidget(): IWidget {
        if (this.drilldownViewList) {
            return this.drilldownViewList()[this.activeDrilldownIndex()].getWidget();
        }
        else {
            //Only for dashboards
            return null;
        }
    }

    get activeReportConfig() : ReportConfig { return this.isReportConfig ? this.getActiveWidget().itemConfig as ReportConfig : null; }

    get isDifferentWidgetType() : boolean {
        return this.isDrilldown && this.tabOrWidget.widgetType() !== this.getActiveWidget().widgetType;
    }

    get reportConfigForDrilldown() : ReportConfig {
        let itemConfig = this.tabOrWidget.itemConfig() as ReportConfig;

        if (this.isDifferentWidgetType) {
            itemConfig = this.getActiveWidget().itemConfig as ReportConfig;
        }

        return itemConfig;
    }

    getDrilldown(index: number): Drilldown {
        return this.drilldownList()[index];
    }
    getActiveDrilldown(): Drilldown {
        return this.getDrilldown(this.activeDrilldownIndex());
    }
    getNextDrilldown(): Drilldown {
        let drilldown = this.getDrilldown(this.activeDrilldownIndex() + 1);
        return drilldown;
    }
    getNextDrilldownObject(): any {
        let drilldown = this.getNextDrilldown();
        return { newDrilldownId: drilldown.id, newReportId: drilldown.id };
    }

    isDrilldownPossible(): boolean {
        //The first click should be to select the widget, once selected, drilldown is enabled
        if (!this.isWiddget || this.dashboardWidget.isSelected) {
            if (this.activeDrilldownIndex() < this.drilldownList().length - 1) {
                return this.getActiveDrilldown().isAggregative;
            }
        }
        return false;
    }

    /** Go back to the root level */
    rollUp() {
        if (this.activeDrilldownIndex() !== 0) {
            this.activeDrilldownIndex(0);
        }
    }

    updateDrilldownList(updatedList: Array<Drilldown>, firstIndexChanged: number, succesFunction: Function, showMessage: boolean = true) {
        let submitObject = this.tabOrWidget.getBaseSubmitObject();
        submitObject.widgetId = this.isWiddget ? this.dashboardWidget.id() : 0;
        submitObject.reports = updatedList.map(function (drilldown) {
                return {
                    drilldownId: drilldown.id,
                    reportId: drilldown.id,
                    order: drilldown.order,
                }
        });

        let o = {
            url: urlConfigs.workBook + "UpdateDrilldownReport",
            data: submitObject,
            dataType: "json",
            async: true,

        } as RequestServerParams;
        o.successFunction = function (this: DrilldownManager, data, e) {
            succesFunction();
            if (showMessage) {
                DevExpress.ui.notify(`Drill-down list saved.`);
            }

            let currentDrilldownId = this.getActiveDrilldown()?.id;

            this.drilldownList.splice(1);
            for (let drilldown of updatedList) {
                this.drilldownList.push(new Drilldown(drilldown));
            }

            if (!this.drilldownList().find(x => x.id === currentDrilldownId)) {
                this.rollUp();
            }
            else {
                if (firstIndexChanged <= this.activeDrilldownIndex()) {
                    this.activeDrilldownIndex(firstIndexChanged);
                }
                this.nextDrilldownId(this.getNextDrilldown()?.id ?? -1);
            }
        }.bind(this);
        o.failureFunction = function (textStatus, failureText, errorItem: IError) {
            errorItem.userMessage = `Failed to save drilldown`;
            irGlobal.defaultErrorFunction(errorItem.userMessage, textStatus, failureText);
        };

        irGlobal.requestServer(o);
    }

    saveDrilldownList(element) {
        let submitObject = this.tabOrWidget.getBaseSubmitObject();
        submitObject.widgetId = this.isWiddget ? this.dashboardWidget.id() : 0,
            submitObject.reports = this.drilldownList.slice(1).map(function (drilldown) {
                return {
                    drilldownId: drilldown.id,
                    reportId: drilldown.id,
                    order: drilldown.order,
                }
            });

        let o = {
            url: urlConfigs.workBook + "UpdateDrilldownReport",
            data: submitObject,
            dataType: "json",
            async: true,

        } as RequestServerParams;
        o.successFunction = function (data, e) {
            DevExpress.ui.notify(`Drill-down list saved.`);
        }.bind(this);
        o.failureFunction = function (textStatus, failureText, errorItem: IError) {
            errorItem.userMessage = `Failed to save drilldown`;
            irGlobal.defaultErrorFunction(errorItem.userMessage, textStatus, failureText);
        };

        irGlobal.requestServer(o);
    }

    get reportTemplateListForDrilldown() {
        if (!this._reportTemplateList) {
            this._reportTemplateList = createInstances(Drilldown, this.tab.workbookConfig.reportTemplateList());
        }
        return ko.computed(function () {
            let drilldownManager = this as DrilldownManager;
            for (let template of drilldownManager._reportTemplateList) {
                let x = drilldownManager.drilldownList().find(x => x.id === template.id);
                if (x && x.order <= drilldownManager.activeDrilldownIndex()) {
                    template.disabled(true);
                }
                else {
                    template.disabled(false);
                }

                template.visible(template.visibility === VisibilityEnum.Normal)
            }
            return drilldownManager._reportTemplateList;
        }, this);
    }
}